<template>
  <div class="app-options-select">
    <slot name="txtHeader"><h2>Optionen buchen</h2></slot>
    <div class="txt-before"><slot name="txtBefore">Wählen Sie hier Ihre Option: </slot></div>
    <div class="options-wrapper">
      <label :for="'option-'+ option.id"
             v-for="option in options" :key="_uid + option.id" class="option-box"
             :id="option.id">
        <div class="option">
          <div class="option-main-box">
            <div class="image">
              <img v-if="option.icon" :src="option.icon">
            </div>
            <div class="checkbox-label">
              <span v-html="option.name"></span>
              <span v-if="option.extraHtml" v-html="option.extraHtml"></span>
              <div class="txt-no-duration option-info" v-if="!option.duration || !option.duration.amount">
                <slot name="txtNoDuration">Gültig bis: unbefristet</slot>
              </div>
              <div class="option-info">
                <p v-if="option.desc" v-html="option.desc"></p>
              </div>
            </div>
          </div>
        </div>
        <div class="info">
          <div class="info-box">
          <span class="option-info" v-if="option.price !== 0 && option.duration && option.duration.amount">
            {{ centsToEuros(option.price) }} / {{option.duration.amount}} {{ durationUnit(option.duration.unit) }}
          </span>
            <span class="txt-for-free option-info" v-if="option.price === 0">
            <slot name="txtForFree">kostenlos</slot>
          </span>
            <div v-if="option.info"
                 v-b-tooltip.hover.bottom="{customClass: 'wide-tooltip'}"
                 :title="option.info"
                 class="info-bubble">
              <div class="hover-toggle"></div>
            </div>
          </div>
        </div>
        <div class="input-checkbox">
          <b-overlay class="btn-overlay" :show="isOptionLoading(option.id)" spinner-small>
            <div v-if="option.statusFlag" class="txt-before-activate-btn">
              <slot name="txtBeforeActivateBtn"></slot>
            </div>
            <div v-else class="txt-before-deactivate-btn">
              <slot name="txtBeforeDeactivateBtn"></slot>
            </div>
            <b-button @click="selectOption(option)" variant="primary">
              <template v-if="option.statusFlag">{{ stepDeactivateLabel }}</template>
              <template v-else>{{ stepBookLabel }}</template>
            </b-button>
          </b-overlay>
        </div>
      </label>
    </div>
  </div>
</template>

<script>
import durationUnit from '@/mixins/durationUnit'

export const stepName = 'view'
export default {
  name: 'OptionsSelectDirect',
  methods: {
    selectOption (option) {
      this.$emit('select-option', option)
    },
    isOptionLoading (id) {
      return this.optionLoading[id] === true
    },
    centsToEuros (value) {
      return this.$config.calendar.formatter.currencyFormatter.format(parseInt(value) / 100)
    }
  },
  props: {
    options: {
      type: Array
    },
    optionLoading: {
      type: Object
    },
    stepDeactivateLabel: {
      type: String
    },
    stepBookLabel: {
      type: String
    }
  },
  mixins: [
    durationUnit
  ]
}
</script>
